import { render, staticRenderFns } from "./formdesigner.vue?vue&type=template&id=e310d8d0"
import script from "./formdesigner.vue?vue&type=script&lang=js"
export * from "./formdesigner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports